import { joinClasses } from '../../primitives/fieldClassSlots';
import {
  lookupExternalAnswer,
  useExternalAnswers,
} from '../ExternalAnswerContext';
import { layoutInlineStyle } from '../layoutInlineStyle';
import type { ExternalAnswerNode } from '../types';

/** Default for `empty` — an em dash, matching how blank chart values read. */
const DEFAULT_EMPTY = '—';

export function ExternalAnswer({ node }: { node: ExternalAnswerNode }) {
  const { answers } = useExternalAnswers();
  const value = lookupExternalAnswer(answers, node.source, node.ref);

  // Nothing to show and the layout asked for silence: render no element at all,
  // so the node's own chrome (a bordered box, a label) goes with it.
  if (value == null && node.hideWhenEmpty) return null;

  // A span, not a div: these sit inline beside their label, and a block element
  // would put every value on its own line.
  return (
    <span
      className={joinClasses('text-sm', node.className)}
      style={layoutInlineStyle(node.style)}
    >
      {node.label != null && node.label !== '' ? (
        <span className={joinClasses('mr-1', node.labelClassName)}>
          {node.label}:
        </span>
      ) : null}
      {value != null && node.list ? (
        value.split(', ').map(item => (
          <span key={item} className='block font-semibold'>
            {item}
          </span>
        ))
      ) : value != null ? (
        <span className='font-semibold'>{value}</span>
      ) : (
        <span className='text-muted-foreground'>
          {node.empty ?? DEFAULT_EMPTY}
        </span>
      )}
    </span>
  );
}
